import React from 'react';
import styled from 'styled-components';
const StyledLabel = styled.div `
  font-size: var(--font-size-xs);
  font-weight: 600;
  text-transform: uppercase;
  color: var(--color-text-submenu);
  letter-spacing: 0.6px;

  padding-bottom: 8px;
  &:not(:first-child) {
    padding-top: 8px;
  }
`;
export function FilterSectionLabel({ label }) {
    return React.createElement(StyledLabel, null, label);
}
